<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-pencil</v-icon>
				編集する
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">作業指示書兼工事日報編集</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row no-gutters justify="end">
					<v-btn color="secondary" class="ml-2" @click="submitForm">
						<v-icon class="mr-1">mdi-content-save</v-icon>
						保存する
					</v-btn>
				</v-row>
				<div class="mt-4">
					<v-row no-gutters>
						<v-col md="8" cols="12">
							<v-sheet elevation="0" max-width="800px">
								<table class="show-dialog-table" width="100%">
									<tbody>
										<template v-if="!$vuetify.breakpoint.xs">
											<tr>
												<th width="15%">顧客名</th>
												<td width="35%">XXXXXX</td>
												<th width="15%">製番</th>
												<td width="35%">2023XXXXXXX</td>
											</tr>
											<tr>
												<th>工事名</th>
												<td>XXXXXXXXXXX</td>
												<th>業者名</th>
												<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											</tr>
											<tr>
												<th>作業日</th>
												<td>
													<v-menu
														ref="menu"
														close-on-content-click
														transition="scale-transition"
														offset-y
														min-width="auto"
													>
														<template v-slot:activator="{ on, attrs }">
															<v-text-field
																v-model="TODO"
																outlined
																dense
																readonly
																hide-details
																v-bind="attrs"
																v-on="on"
															/>
														</template>
														<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
													</v-menu>
												</td>
												<th>定時</th>
												<td>
													<v-row no-gutters align="center">
														<v-text-field v-model="TODO" dense outlined hide-details type="time" />
														<p class="px-1">〜</p>
														<v-text-field v-model="TODO" dense outlined hide-details type="time" />
													</v-row>
												</td>
											</tr>
											<tr v-if="$vuetify.breakpoint.smAndDown">
												<th>入力者</th>
												<td>{{ $store.getters["auth/authData"].full_name }}</td>
											</tr>
										</template>
										<template v-else>
											<tr>
												<th width="30%">顧客名</th>
												<td width="70%">XXXXXX</td>
											</tr>
											<tr>
												<th>製番</th>
												<td>2023XXXXXXX</td>
											</tr>
											<tr>
												<th>工事名</th>
												<td>XXXXXXXXXXX</td>
											</tr>
											<tr>
												<th>業者名</th>
												<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											</tr>
											<tr>
												<th>作業日</th>
												<td>
													<v-menu
														ref="menu"
														close-on-content-click
														transition="scale-transition"
														offset-y
														min-width="auto"
													>
														<template v-slot:activator="{ on, attrs }">
															<v-text-field
																v-model="TODO"
																outlined
																dense
																readonly
																hide-details
																v-bind="attrs"
																v-on="on"
															/>
														</template>
														<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
													</v-menu>
												</td>
											</tr>
											<tr>
												<th>定時</th>
												<td>
													<v-row no-gutters align="center">
														<v-text-field v-model="TODO" dense outlined hide-details type="time" />
														<p class="px-1">〜</p>
														<v-text-field v-model="TODO" dense outlined hide-details type="time" />
													</v-row>
												</td>
											</tr>
											<tr>
												<th>入力者</th>
												<td>{{ $store.getters["auth/authData"].full_name }}</td>
											</tr>
										</template>
									</tbody>
								</table>
							</v-sheet>
						</v-col>
						<v-col v-if="!$vuetify.breakpoint.smAndDown" md="4" cols="0">
							<v-sheet elevation="0" max-width="400px">
								<table class="show-dialog-table" width="100%">
									<tbody>
										<tr>
											<th width="30%">入力者</th>
											<td width="70%">{{ $store.getters["auth/authData"].full_name }}</td>
										</tr>
									</tbody>
								</table>
							</v-sheet>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col md="6" cols="12" class="mt-2 pr-0 pr-md-2">
							<table class="show-dialog-table" width="100%">
								<tbody>
									<tr>
										<th width="30%">本日の作業予定</th>
										<td colspan="2" width="70%">
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
									<tr>
										<th>安全指示事項</th>
										<td colspan="2">
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
									<tr>
										<th rowspan="5">掲示物</th>
										<td colspan="2">
											<v-row no-gutters>
												<v-checkbox v-model="TODO" hide-details />有機主の職務
											</v-row>
										</td>
									</tr>
									<tr>
										<td colspan="2">
											<v-row no-gutters>
												<v-checkbox v-model="TODO" hide-details />有機注意事項
											</v-row>
										</td>
									</tr>
									<tr>
										<td colspan="2">
											<v-row no-gutters> <v-checkbox v-model="TODO" hide-details />有機区分 </v-row>
										</td>
									</tr>
									<tr>
										<td colspan="2">
											<v-row no-gutters>
												<v-checkbox v-model="TODO" hide-details />酸欠主の職務
											</v-row>
										</td>
									</tr>
									<tr>
										<td colspan="2">
											<v-row no-gutters>
												<v-checkbox v-model="TODO" hide-details />酸欠の予防心得
											</v-row>
										</td>
									</tr>
									<tr>
										<th rowspan="2">作業主任者</th>
										<th width="20%">有機主</th>
										<td width="50%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th>酸欠主</th>
										<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
								</tbody>
							</table>
						</v-col>
						<v-col md="6" cols="12" class="mt-2 pl-0 pl-md-2">
							<table width="100%" class="show-dialog-table">
								<tbody>
									<tr>
										<th width="30%">明日の予定</th>
										<td width="70%">
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
									<tr>
										<th width="30%">連絡・打合せ事項</th>
										<td width="70%">
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
									<tr>
										<th width="30%">備考</th>
										<td width="70%">
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
								</tbody>
							</table>
						</v-col>
					</v-row>
					<div class="my-4">
						<h6 class="text-body-1 font-weight-bold">作業工数</h6>
						<div class="table-container mt-2">
							<table class="show-dialog-table" width="100%" style="min-width: 1400px">
								<thead>
									<tr>
										<th :style="width(120)" rowspan="2">氏名</th>
										<th :style="width(100)" rowspan="2">出勤(⚪︎)</th>
										<th :style="width()" colspan="6">作業資格証の有</th>
										<th :style="width(220)" rowspan="2">残業(H)</th>
										<th :style="width(90)" rowspan="2">延工数(工)</th>
										<th :style="width(90)" rowspan="2">延残業(H)</th>
										<th :style="width(70)" rowspan="2">宿泊(⚪︎)</th>
										<th :style="width(90)" rowspan="2">延宿泊(日)</th>
										<th :style="width(250)" rowspan="2">移動等</th>
									</tr>
									<tr>
										<th :style="width(50)">有機</th>
										<th :style="width(50)">酸欠</th>
										<th :style="width(50)">職長</th>
										<th :style="width(50)">砥石</th>
										<th :style="width(50)">ハーネス</th>
										<th :style="width(250)">
											<v-row no-gutters justify="center" class="flex-nowrap">
												<p>その他</p>
												<v-text-field
													class="ml-2"
													background-color="white"
													v-model="TODO"
													dense
													outlined
													hide-details
											/></v-row>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="n of 3" :key="n">
										<td>XX XX</td>
										<td><v-checkbox v-model="TODO" hide-details /></td>
										<td>XX</td>
										<td>XX</td>
										<td>XX</td>
										<td>XX</td>
										<td>XX</td>
										<td><v-checkbox v-model="TODO" hide-details /></td>
										<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										<td>XX</td>
										<td>XX</td>
										<td><v-checkbox v-model="TODO" hide-details /></td>
										<td>XX</td>
										<td>
											<v-textarea v-model="TODO" rows="1" dense outlined hide-details auto-grow />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import dialogMixin from "../../../helper/dialogMixin"

export default {
	mixins: [dialogMixin("withBtn")],
	props: {
		schedule_data: {
			type: Object,
			required: false,
			default: () => {},
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			schedule: {},
			TODO: null,
			common,
			rules,
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/schedules/${this.schedule.id}`
			const params = {}
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
					this.$emit("update-schedule", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		width(number) {
			return {
				width: number + "px",
				minWidth: number + "px",
				maxWidth: number + "px",
			}
		},
	},
	computed: {},
	watch: {
		schedule_data: {
			handler(val) {
				this.schedule = val
			},
			deep: true,
		},
	},
}
</script>

<style lang="scss" scoped>
thead {
	th {
		background-color: whitesmoke !important;
		border-right: 1px solid white;
	}
}
th {
	background-color: whitesmoke;
	border-right: 1px solid white;
	font-weight: bold;
	padding: 4px;
}
td {
	border-bottom: 1px solid whitesmoke;
	padding: 4px;
	border-right: 1px solid whitesmoke;
	&:first-child {
		border-left: 1px solid whitesmoke;
	}
}
</style>